import React from 'react';
import { FileWarningIcon } from 'lucide-react';
import { customs } from '../data/operations';
export function CustomsHolds() {
  return <section className="border border-slate-700/80 bg-[#09131c]" aria-labelledby="customs-heading" data-id="element-26">
      <div className="flex items-center justify-between border-b border-slate-700/70 px-3 py-2.5" data-id="element-27">
        <div className="flex items-center gap-2" data-id="element-28">
          <FileWarningIcon className="h-4 w-4 text-violet-300" aria-hidden="true" data-id="element-29" />
          <div data-id="element-30">
            <h2 id="customs-heading" className="font-display text-xs font-bold tracking-[0.14em] text-slate-100" data-id="element-31">
              CUSTOMS HOLDS
            </h2>
            <p className="font-mono text-[8px] text-slate-500" data-id="element-32">
              ESCALATION QUEUE
            </p>
          </div>
        </div>
        <span className="font-mono text-[9px] text-violet-300" data-id="element-33">27 UNITS</span>
      </div>
      <div className="divide-y divide-slate-800" data-id="element-34">
        {customs.map((hold, index) => <div key={hold.port} className="flex items-center gap-3 px-3 py-3" data-id="element-35">
            <span className={`grid h-7 w-7 shrink-0 place-items-center border font-mono text-[9px] ${index === 0 ? 'border-red-400/40 text-red-300' : 'border-violet-400/30 text-violet-300'}`} data-id="element-36">
              {hold.units}
            </span>
            <div className="min-w-0 flex-1" data-id="element-37">
              <div className="flex justify-between gap-3" data-id="element-38">
                <span className="font-mono text-[10px] font-bold text-slate-200" data-id="element-39">
                  {hold.port}
                </span>
                <span className={`font-mono text-[9px] ${index === 0 ? 'text-red-300' : 'text-amber-300'}`} data-id="element-40">
                  {hold.age}
                </span>
              </div>
              <p className="mt-1 truncate text-[10px] text-slate-500" data-id="element-41">
                {hold.reason}
              </p>
            </div>
          </div>)}
      </div>
      <button className="w-full border-t border-slate-700 py-2 font-mono text-[9px] tracking-wider text-slate-500 transition-colors hover:bg-violet-400/5 hover:text-violet-300 focus:outline-none focus:ring-1 focus:ring-inset focus:ring-cyan-400" data-id="element-42">
        OPEN CLEARANCE CONSOLE →
      </button>
    </section>;
}